export default __webpack_public_path__ + "static/ga-logo-01a4e5b5206b9a575dd66fae103f0129.svg";